
import { Action } from '@ngrx/store';
import { PersonalDetails } from '../../model/ngrx/personal-details.model';
import * as PersDetailsActions from './../actions/personal-details.actions';

export type Actions = PersDetailsActions.Actions;

const initialState: PersonalDetails = {
    contactNumber: '',
    dateOfBirth: '',
    emailAddress: '',
    forename: '',
    gender: '',
    maritalStatus: '',
    postcode: '',
    surname: '',
    ukaddressIndicator: '',
    consentDate: '',
    consentIndicator: '',
    pwAppointmentdate: '',
    customerCareInfo: null
};

export function persDetailsReducer(state: PersonalDetails[] = [initialState], action: PersDetailsActions.Actions) {
    switch (action.type) {
        case PersDetailsActions.ADD_PERSONAL_DETAILS:
            return [...state, action.payload];
        case PersDetailsActions.REMOVE_PERSONAL_DETAILS:
            state = [];
            return state;

        default:
            return state;
    }
}
